export const fileServiceMessages = {
  FALLBACK_ERROR: 'An error occurred',
  GET_FILE_MAPPING_ERROR: 'Unable to retrieve folders',
  PREVIEW: {
    ERROR: 'Unable to open file preview',
  },
  PERMISSIONS: {
    GET_USERS_ERROR: 'Unable to get users',
    GET_USER_ERROR: 'Unable to get user',
    GET_GROUPS_ERROR: 'Unable to get groups',
    UPDATE_PERMISSIONS_SUCCESS: 'Permissions updated successfully',
    UPDATE_PERMISSIONS_ERROR: 'Unable to update permissions',
    GET_PERMISSIONS_ERROR: 'Unable to get permissions',
  },
};
